import React from "react";
import "./Notfound.css";
import Logo from "../../assest/logo.png";
import Banner404 from "../../assest/404.png";
import Banner_Error from "../../assest/error.png";
const Notfound = ({ error }) => {
  return (
    <div className="h-full w-[90%] mx-auto">
      <div className="">
        <img
          src={Logo}
          alt="Dlearners logo"
          className="w-[20%] max-w-[200px] min-w-[150px]"
        />
      </div>
      {!error ? (
        <div className="flex items-center justify-between h-[90%] max-[700px]:flex-col max-[700px]:justify-center max-[700px]:items-start">
          <div className="w-[40%] flex flex-col justify-center   max-[700px]:w-[100%]  max-[700px]:h-[50%]">
            <h2 className="text-4xl font-bold mb-5">
              Oops! <br />
              Page not found{" "}
            </h2>
            <p className="text-sm font-medium mt-3">
              This Page Does not exist or was removed! We suggest you back to
              home.
            </p>
          </div>
          <div className="flex items-center justify-center max-[700px]:h-[50%] max-[700px]:items-start ">
            <img
              src={Banner404}
              alt="404"
              className="w-[70%]  max-[700px]:w-[100%]"
            />
          </div>
        </div>
      ) : (
        <div className="flex items-center flex-col justify-center h-[90%] max-[700px]:flex-col max-[700px]:justify-center max-[700px]:items-start">
          <div className="w-[40%] flex flex-col justify-center min-[700px]:mb-20  max-[700px]:w-[100%]  max-[700px]:h-[50%]">
            <h2 className="text-4xl font-bold min-[700px]:text-center">
              We'll Be Back Soon
            </h2>

            <p className="text-sm font-medium mt-3 min-[700px]:text-center">
              Dlearners is down for scheduled maintenance and expert to back
              online in a few minutes.
            </p>
          </div>
          <div className="flex items-center justify-center max-[700px]:h-[50%] max-[700px]:items-start ">
            <img
              src={Banner_Error}
              alt="404"
              className="w-[70%]  max-[700px]:w-[100%]"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Notfound;
